import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PORTAL, siteUrl } from '../lib/portal';
import { useSettings } from '../store/settings';
import { Icon } from './Icon';

/** How long the notice stays up before it gets out of the way by itself. */
const NOTICE_MS = 6000;

/** Portal builds skip our landing page, so new players learn here what's stored about them. Never in the way of play. */
export function PortalNotice() {
  const { t } = useTranslation();
  const seen = useSettings((s) => s.seenPortalNotice);
  const set = useSettings((s) => s.set);
  const showing = !!PORTAL && !seen;
  useEffect(() => {
    if (!showing) return;
    const timer = window.setTimeout(() => set({ seenPortalNotice: true }), NOTICE_MS);
    return () => window.clearTimeout(timer);
  }, [showing, set]);
  if (!showing) return null;
  return (
    <div className="portal-notice" role="status">
      <span className="grow">
        {t('settings.portalNotice')}{' '}
        <a href={siteUrl('/privacy')} target="_blank" rel="noopener">{t('settings.privacy')}</a>
        {' · '}
        <a href={siteUrl('/terms')} target="_blank" rel="noopener">{t('settings.terms')}</a>
      </span>
      <button className="btn ghost small icon" onClick={() => set({ seenPortalNotice: true })} aria-label={t('common.close')}><Icon name="x" size={16} /></button>
    </div>
  );
}
